module.exports = __webpack_public_path__ + "img/dep_fishandseafood.ce3f5c54.png";